var map = {
	"../pages/articulo/articulo.module": [
		282,
		12
	],
	"../pages/carrito/carrito.module": [
		287,
		11
	],
	"../pages/correo/correo.module": [
		285,
		10
	],
	"../pages/factura/factura.module": [
		286,
		9
	],
	"../pages/home/home.module": [
		283,
		8
	],
	"../pages/login/login.module": [
		284,
		7
	],
	"../pages/new/new.module": [
		289,
		6
	],
	"../pages/pago/pago.module": [
		292,
		5
	],
	"../pages/perfil/perfil.module": [
		288,
		4
	],
	"../pages/productos/productos.module": [
		294,
		3
	],
	"../pages/registrar/registrar.module": [
		291,
		2
	],
	"../pages/reparacion/reparacion.module": [
		290,
		1
	],
	"../pages/validar/validar.module": [
		293,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 163;
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy
// module id = 163
// module chunks = 13